var React = require('react');

function Gmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M479.536 58.794H32.464C14.564 58.794 0 73.358 0 91.258v329.483c0 17.9 14.564 32.464 32.464 32.464h447.072c17.9 0 32.464-14.564 32.464-32.464V91.258c0-17.9-14.564-32.464-32.464-32.464zm-41.669 18.373L256 209.723 74.133 77.167h363.734zM57.569 434.832H32.464c-7.769 0-14.091-6.322-14.091-14.091V135.199l39.196 28.569v271.064zm378.488 0H75.943V177.161L250.59 304.457a9.168 9.168 0 0 0 5.41 1.763c1.9 0 3.8-.588 5.41-1.763L436.057 177.16v257.672zm57.57-14.091c0 7.769-6.322 14.091-14.091 14.091h-25.105V163.768l39.196-28.569v285.542zm0-308.277L256 285.665 18.373 112.464V91.258c0-7.769 6.322-14.091 14.091-14.091H42.94l207.65 151.348a9.17 9.17 0 0 0 5.41 1.763 9.17 9.17 0 0 0 5.41-1.763L469.059 77.167h10.476c7.769 0 14.091 6.322 14.091 14.091v21.206z"}));
}

Gmail.defaultProps = {"fill":"#a8abb6","viewBox":"0 0 512 512"};

module.exports = Gmail;

Gmail.default = Gmail;
